import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { FLIP, PREVENT_OVERFLOW, ARROW } from '@cian/popper-fork';
import { clsx } from 'clsx';
import { Popper } from '../../../internal/components/Popper';
import { CloseButton } from '../../../internal/components/CloseButton';
import { Outside } from '../../../services';
import { getStyles } from './styles';

/**
 * Компонент для создания кастомных тултипов
 *
 * @export
 * @param {ICustomTooltipProps} props
 * @returns
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CustomTooltip(_ref) {
  let {
    theme = 'white',
    size = 'S',
    placement = 'top',
    maxWidth = 450,
    portal = true,
    portalElement,
    flip = true,
    preventOverflow = true,
    content,
    header,
    anchorRef,
    open,
    arrow,
    closeButton,
    outside,
    minHeight,
    withoutPadding,
    onClose = () => {},
    onMouseEnter,
    onMouseLeave
  } = _ref;
  const styles = getStyles(theme, size);
  const modifiers = React.useMemo(() => {
    return [flip && FLIP, preventOverflow && PREVENT_OVERFLOW, arrow && _objectSpread(_objectSpread({}, ARROW), {}, {
      options: {
        padding: 12
      }
    })].filter(Boolean);
  }, [flip, preventOverflow, arrow]);
  const tooltip = /*#__PURE__*/_jsxs("div", {
    className: clsx(styles['tooltip'], arrow && styles['arrow_tooltip'], closeButton && styles['close_tooltip'], withoutPadding && styles['without_padding']),
    style: {
      minHeight,
      maxWidth
    },
    children: [closeButton && /*#__PURE__*/_jsx(CloseButton, {
      onClick: onClose,
      className: clsx(styles['close']),
      size: 12,
      theme: getCloseTheme(theme)
    }), arrow && /*#__PURE__*/_jsx("div", {
      "data-popper-arrow": true,
      className: styles['arrow']
    }), header && /*#__PURE__*/_jsx("div", {
      className: clsx(styles['header']),
      children: header
    }), content]
  });
  return /*#__PURE__*/_jsxs(Popper, {
    open: open,
    anchorRef: anchorRef,
    placement: placement,
    portal: portal,
    portalElement: portalElement,
    modifiers: modifiers,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: [outside && /*#__PURE__*/_jsx(Outside, {
      onOutside: onClose,
      active: true,
      insideRefs: [anchorRef],
      children: tooltip
    }), !outside && tooltip]
  });
}
function getCloseTheme(tooltipTheme) {
  switch (tooltipTheme) {
    case 'black':
      return 'gray';
    case 'gray':
      return 'light';
    case 'blue':
      return 'light';
    case 'white':
      return 'dark';
  }
}